import { ViewStream } from "spyne";
import { AuthViewLoginBtn } from "components/auth/auth-view-login-btn";
import { AuthViewProfile } from "components/auth/auth-view-profile";

export class AuthView extends ViewStream {
  constructor(props = {}) {
    props.id = "auth-view";
    props.channels = ["CHANNEL_AUTH"];
    props.isAuthenticated = -1;

    super(props);
  }

  addActionListeners() {
    return [
      ["CHANNEL_AUTH_AUTHENTICATION_EVENT", "auth$onAuthenticationEvent"],
    ];
  }

  auth$onAuthenticationEvent(e, props = this.props) {
    const { isAuthenticated,isAuthenticatedForBasicInfo, userRecord, userProfile } = e.payload;
    //console.log("THIS IS ",{ isAuthenticated, userRecord, userProfile });

    if (isAuthenticatedForBasicInfo !== this.props.isAuthenticated) {
      this.props.isAuthenticated = isAuthenticatedForBasicInfo;
      this.props.el$.toggleClass("authenticated", isAuthenticatedForBasicInfo);

      const viewClass = isAuthenticatedForBasicInfo ? AuthViewProfile : AuthViewLoginBtn;
      let data = { ...userProfile, userRecord };

      //console.log("AUTH VIEW ", { data, userRecord, e });
      this.appendView(new viewClass({ data }));
    }

    //console.log("VIEW IS ", isAuthenticated);
  }

  broadcastEvents() {
    return [];
  }

  onRendered() {}
}
